import { Button } from 'components';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import ModalUploadTM from './ModalUploadTM';

interface IUploader {
  searchRefetch: () => void;
}

const Uploader: FC<IUploader> = ({ searchRefetch }) => {
  const t = useTranslations();

  const [openModal, setOpenModal] = useState(false);

  const handleToggleModal = () => setOpenModal((oldState) => !oldState);

  return (
    <>
      <Button size="large" onClick={handleToggleModal}>
        {t('translation_memory.upload_file')}
      </Button>
      <ModalUploadTM open={openModal} onCancel={handleToggleModal} searchRefetch={searchRefetch} />
    </>
  );
};

export default Uploader;
